import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import "./dpoMyChecklist.css";
import { Select, Button, Checkbox, Col, Row } from "antd";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { isEmpty } from "lodash";

import MainObligations from "./MainObligations";

//import TasksPerOwner from "../../components/obligationsPerOwner/obligationsPerOwner";
import TasksPerOwnerV2 from "../../components/tasksPerOwnerV2/TasksPerOwnerV2";

import { labelOfFramework } from "../../util/labelOf";
import CircleGauge from "../../components/circleGauge/CircleGauge";

import { massAssignObligations } from "../../store/obligations/actions";
// import { sendEmail } from "../../store/email/actions";
import { renderOptions } from "../../util/basicRenders";
// import { assignToUserMessage } from "../../util/emailTemplates";
import FilterObligations from "../../components/filterObligations/FilterObligations";
// import {
//   setOblFilterField,
//   setObligationCategory
// } from "../../store/forms/actions";
import { filterObligations } from "../../util/filters";
import { sortObligationsBy } from "../../util/sorters";
import { ReactComponent as Triangle} from "../../assets/purple-triangle.svg";

const DpoMyChecklist = () => {
  const dispatchito = useDispatch();
  dayjs.extend(customParseFormat);

  let params = new URL(document.location).searchParams;
  let cat = params.get("category");

  const today = new Date();

  const user = useSelector(state => state.user);
  const organizationId = useSelector(
    state => state.organizations.organizationId
  );
  const usersData = useSelector(state => state.organizations.usersData);
  const originalObligations = useSelector(
    state => state.obligations.obligations
  );
  const obligations = useSelector(state => state.obligations.forms);
  const laws = useSelector(state => state.laws.laws);
  const loading = useSelector(state => state.forms.loading);
  const uniqueMainCategories = useSelector(state => state.laws.lawCategories);

  // const [category, setCategory] = useState(cat);
  const category = useSelector(state => state.forms?.selectedCategory);
  const searchTerm = useSelector(state => state.forms?.searchTerm);
  const dueDateFrom = useSelector(state => state.forms?.dueDateFrom);
  const dueDateTo = useSelector(state => state.forms?.dueDateTo);
  const selectedAction = useSelector(state => state.forms?.selectedAction);
  const selectedAssessment = useSelector(
    state => state.forms?.selectedAssessment
  );

  const [obligationsInCategory, setObligationsInCategory] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const startIndex = (currentPage - 1) * 5;
  const endIndex = startIndex + 5;

  const sortingTypes = ["", "asc", "desc"];
  const [sortingOrder, setSortingOrder] = useState(sortingTypes[0]);
  const [orderBy, setOrderBy] = useState("");

  const filteredUsers = useSelector(state => state.forms?.filteredUsers);
  const filterUsers = useSelector(state => state.forms?.filterUsersEnabled);
  const filteredObligations =
    filterUsers ||
    category ||
    searchTerm ||
    dueDateFrom ||
    dueDateTo ||
    selectedAction ||
    selectedAssessment
      ? filterObligations({
          obligationList: originalObligations,
          flag: "main",
          filters: {
            filterUsers,
            filteredUsers,
            category,
            searchTerm,
            action: selectedAction,
            assessment: selectedAssessment,
            dueDateFrom,
            dueDateTo
          }
        })
      : originalObligations;
  const filteredObligationsForm = sortingOrder || orderBy ?
    !isEmpty(obligations) && !isEmpty(filteredObligations)
      ? sortObligationsBy(filteredObligations, "main", orderBy, sortingOrder)?.map(o => {
        const relevantObligation = obligations?.find(obl => o._id === obl._id)
        return relevantObligation;
      })
      : sortObligationsBy(filteredObligations, "main", orderBy, sortingOrder) 
      : filteredObligations?.map(o => {
        const relevantObligation = obligations?.find(obl => o._id === obl._id)
        return relevantObligation;
      });
  const displayedItems = filteredObligationsForm
    ? filteredObligationsForm.slice(startIndex, endIndex)
    : [];

  //set local state
  //set local state for selected obligations
  const [selectedObligations, setSelectedObligations] = useState([]);
  const [massAssignSelectedPersonId, setMassAssignSelectedPersonId] =
    useState("");
  const [searchValue, setSearchValue] = useState("");

  const sortedUniqueMainCategories = uniqueMainCategories
    ? uniqueMainCategories.toSorted((a, b) => a.label.localeCompare(b.label))
    : [];

  const currentUsersData = usersData
    ? usersData?.filter(b =>
        user.role === "assignedUser"
          ? b._id === user.userId || b.role === "corporateComplianceAssessor"
          : b.role === "assignedUser" ||
            b.role === "corporateComplianceAssessor"
      )
    : [];

  const panelStyle = {
    marginBottom: 24,
    borderRadius: 16,
    border: "none"
  };

  const toggleOrder = () => {
    const currentIndex = sortingTypes.indexOf(sortingOrder);
    const nextIndex = (currentIndex + 1) % sortingTypes.length;
    setSortingOrder(sortingTypes[nextIndex]);
    return sortingTypes[nextIndex];    
  };

  //handlers
  const handleChangeObl = ({ event, id, key, type }) => {
    const index = obligations.findIndex(item => item._id === id);
    const value =
      type === "select"
        ? event
        : type === "date"
        ? new Date(event).toISOString()
        : event.target.value;

    dispatchito({
      type: "UPDATE_OBLIGATION_FORMS",
      payload: { index, value, key }
    });
  };

  const handleClearMessage = ({ event, id, key, type }) => {
    const index = obligations.findIndex(item => item._id === id);
    dispatchito({
      type: "UPDATE_OBLIGATION_FORMS",
      payload: { index, event, key }
    });
  };

  const handleMassAssign = async (items, targetUserId) => {
    if (isEmpty(items)) return;

    const oblIds = items.map(i => {
      return i._id;
    });
    dispatchito(
      massAssignObligations({
        targetUserId,
        oblIds,
        user,
        organizationId,
        callback: check => {
          setMassAssignSelectedPersonId("");
          setChecked(check);
          setSelectedObligations([]);
          // const userAssigned = usersData?.find(
          //   item => item._id === targetUserId
          // );
          // if (targetUserId) {
          //   items.forEach(item => {
          //     const law = laws?.find(law => law._id === item.law_id);
          //     dispatchito(
          //       sendEmail({
          //         user,
          //         to: [userAssigned.email],
          //         cc: [],
          //         subject: "Assign Main Obligations",
          //         message: assignToUserMessage(item, user, false, law),
          //         isHtmlMessage: true
          //         // message: 'HELLO text',
          //         // isHtmlMessage: false,
          //       })
          //     );
          //   });
          // }
        }
      })
    );
  };

  const handleSortClick = (by) => {
    if (orderBy !== by) {
      setSortingOrder("asc");
    }
    else {
      toggleOrder();
      }
    setOrderBy(by);
  }

  const getCategoryScore = category => {
    console.debug({ category });
    const filteredOblInCategory = obligations?.filter(item=>item.assessment!=="na");
    let oblInCategory = filteredOblInCategory
      ? category
        ? filteredOblInCategory.filter(item => {
            const inForceDate = new Date(item?.inForceDate);
            return item.mainCategory === category && inForceDate <= today;
          })
        : filteredOblInCategory.filter(item => {
            const inForceDate = new Date(item?.inForceDate);
            return inForceDate <= today;
          })
      : [];

    //temp code only for trouble shooting
    const inForceObligationsOfCategory = !isEmpty(oblInCategory)
      ? oblInCategory.map(o => {
          return {
            a: o?.article,
            p: o?.paragraph,
            desc: o?.description,
            inForce: o?.inForceDate,
            cat: o.mainCategory
          };
        })
      : [];
    console.debug({ inForceObligationsOfCategory });

    // console.debug("oblInCategory:", oblInCategory);
    let oblScore = oblInCategory?.filter(item => {
      return item.assessment === "Compliant";
    }).length;
    console.debug("oblInCategory:", oblInCategory.length);
    console.debug({ oblScore });

    let percentage =
      oblInCategory.length === 0 ? 0 : (oblScore / oblInCategory.length) * 100;
    let roundedPercentage = Math.round(percentage); // Round to nearest whole number

    // console.debug("INSIDE getCategoryScore percentage", roundedPercentage);
    return roundedPercentage;
  };

  useEffect(() => {
    if (!isEmpty(category)) {
      let oblInCategory = originalObligations
        ? originalObligations.filter(item => item.mainCategory === category)
        : [];
      setObligationsInCategory(oblInCategory);
    } else {
      setObligationsInCategory(originalObligations);
    }
  }, [category, originalObligations]);

  const targetId = useSelector(state => state.obligations.navigateId);
  const [firstRender , setFirstRender] = useState(false);
  const [scrolled , setScrolled] = useState(false);
  useEffect(() => {
    if (targetId === 0 && scrolled) {
      if(firstRender){
        setCurrentPage(1);
        // setSortingOrder(sortingTypes[0]);
        // setOrderBy("");
      }
      setFirstRender(true);
    }
  }, [filterUsers, organizationId, category, searchTerm, dueDateFrom, dueDateTo, selectedAction, selectedAssessment]);

  const [checked, setChecked] = useState(false);
  const onCheckboxAllChange = () => {
    if (checked) {
      setSelectedObligations([]);
      setChecked(false);
    } else {
      const uniqueValuesSet = new Set([
        ...selectedObligations,
        ...displayedItems
      ]);
      const uniqueValuesArray = Array.from(uniqueValuesSet);
      setSelectedObligations(uniqueValuesArray);
      setChecked(true);
    }
  };

  return (
    <div className="ob" id="ob-page">
      <FilterObligations
        defaultCat={cat}
        organizationId={organizationId}
        sortedUniqueMainCategories={sortedUniqueMainCategories}
        obligationType="main"
      />
      <Row
        className="mb-3"
        id="ob-page-rows-mb-3"
        gutter={{ xs: 8, sm: 12, md: 24, lg: 22 }}
      >
        <Col span={17} style={{}}>
          <TasksPerOwnerV2
            users={usersData ?? []} // Check the existence of usersData here
            obligations={obligationsInCategory ?? []}
          />
        </Col>
        <Col span={1} flex="1.938rem"></Col>
        <Col span={6} style={{}}>
          <div
            className="compliance-score-content"
            id="ob-page-compliance-score-content"
          >
            <h4 className="component-title" id="ob-page-component-title">
              Compliance Score
            </h4>
            {/* <ScoreGauge title={category} score={getCategoryScore(category)} /> */}
            <p
              style={{
                margin: "0",
                padding: "0",
                minHeight: "1.188rem",
                textAlign: "left",
                paddingLeft: "1.563rem",
                color: "#8B69BC",
                fontFamily: "Roboto",
                fontSize: "1rem",
                fontStyle: "normal",
                fontWeight: "500",
                lineHeight: "normal"
              }}
            >
              {!category ? "" : labelOfFramework(category)}
            </p>
            <div
              className="compliance-score-gauge"
              id="ob-page-compliance-score-gauge"
            >
              {!isEmpty(obligations) ? (
                <CircleGauge score={getCategoryScore(category)} />
              ) : (
                <CircleGauge score={0} />
              )}{" "}
            </div>
          </div>
        </Col>
        {/* {user?.role !== "groupComplianceAssessor" && <Col span={6}></Col>} */}
        {/* <Col span={2}></Col> */}
      </Row>

      <div className="shaded-border" id="ob-page-shaded-border">
        <div className="obligation-table" id="ob-page-obligation-table">
          <div className="large-titles-black" id="ob-page-large-titles-black">
            Main Obligations
          </div>
          <div
            style={{
              width: "99.7%",
              height: "100%",
              border: "0.063rem #D5D0C9 solid"
            }}
          ></div>
          <div
            id="mass-assign"
            style={{ display: "flex", gap: "0.25rem", marginTop: "0.813rem" }}
          >
            <Checkbox
              id="ob-page-checkbox"
              style={{
                marginTop: "5px",
                marginLeft: "-23px"
              }}
              checked={checked}
              onChange={e => onCheckboxAllChange()}
              disabled={
                user.role === "corporateComplianceObserver" ||
                user.role === "groupComplianceObserver"
              }
            />
            <Select
              // dropdownStyle={{ maxHeight: "17rem" }}
              virtual={false}
              id={user.email}
              style={{ width: "15rem", textAlign: "left" }}
              className="assign-select mb-2"
              showSearch
              allowClear={!!massAssignSelectedPersonId}
              onSearch={setSearchValue}
              filterOption={false}
              placeholder="Select..."
              disabled={user.role.includes("Observer")}
              onChange={value => setMassAssignSelectedPersonId(value)}
              value={
                !massAssignSelectedPersonId
                  ? massAssignSelectedPersonId
                  : currentUsersData &&
                    !isEmpty(currentUsersData) &&
                    Array.isArray(currentUsersData) &&
                    currentUsersData?.length > 0 &&
                    currentUsersData
                      ?.filter(b => b._id === massAssignSelectedPersonId)
                      .map(b => `${b.firstName} ${b.lastName}`)
              }
            >
              {/* {console.debug("usersData value:", usersData)} */}
              {currentUsersData && renderOptions(searchValue, currentUsersData)}
            </Select>
            {user.role !== "corporateComplianceObserver" &&
              user.role !== "groupComplianceObserver" && (
                <div
                  id="mass-assign-div"
                  onClick={() =>
                    handleMassAssign(
                      selectedObligations,
                      massAssignSelectedPersonId
                    )
                  }
                >
                  <Button
                    className="assign-button-rc no-margin"
                    id="ob-page-assign-button-rc-no-margin"
                    type="text"
                    size="medium"
                  >
                    Assign
                  </Button>
                </div>
              )}
          </div>
          <Row
            className="mb-2"
            id="ob-page-rows-mb-2"
            gutter={{ xs: 8, sm: 12, md: 24, lg: 22 }}
            style={{ marginLeft: "1.6rem", marginRight: "2rem" }}
          >
            {/* <Col span={1}>
              <span className="title-style"></span>
            </Col> */}
            {/* <Col span={1}>
              <span className="title-style">ID</span>
            </Col> */}
            <Col></Col>
            <Col
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-end",
                paddingRight: 0,
                paddingLeft: 0
                // position: "relative"
              }}
              className="checklist-title-col"
              id="ob-page-checklist-title-col"
            >
              <span className="title-style sortable" id="ob-page-title-style-2"
                onClick={() => handleSortClick("law_title")}
              >
                {`Law`}{orderBy === "law_title" && sortingOrder ? sortingOrder === "desc" ? <Triangle/> : <Triangle style={{transform: "rotate(180deg)"}}/> : <></>}
              </span>
            </Col>
            <Col
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-end",
                paddingRight: 0,
                paddingLeft: 0
              }}
              className="checklist-category-col"
            >
              <span
                className="title-style sortable"
                id="ob-page-title-style-3"
                style={{ paddingLeft: "0.063rem" }}
                onClick={() => handleSortClick("mainCategory")}
              >
                Category{orderBy === "mainCategory" && sortingOrder ? sortingOrder === "desc" ? <Triangle/> : <Triangle style={{transform: "rotate(180deg)"}}/> : <></>}
              </span>
            </Col>
            <Col
              // span={1}
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-end",
                paddingRight: 0,
                paddingLeft: 0
              }}
              className="checklist-article-col"
            >
              <span
                className="title-style sortable"
                id="ob-page-title-style-4"
                style={{
                  paddingLeft: "0.063rem"
                }}
                onClick={() => handleSortClick("article")}
              >
                Art.{orderBy === "article" && sortingOrder ? sortingOrder === "desc" ? <Triangle/> : <Triangle style={{transform: "rotate(180deg)"}}/> : <></>}
              </span>
            </Col>
            <Col
              // span={1}
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-end",
                paddingRight: 0,
                paddingLeft: 0
              }}
              className="checklist-paragraph-col"
            >
              <span
                className="title-style sortable"
                id="ob-page-title-style-5"
                style={{ paddingLeft: "1px" }}
                onClick={() => handleSortClick("paragraph")}
              >
                Par.{orderBy === "paragraph" && sortingOrder ? sortingOrder === "desc" ? <Triangle/> : <Triangle style={{transform: "rotate(180deg)"}}/> : <></>}
              </span>
            </Col>
            <Col
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-end",
                paddingRight: 0,
                paddingLeft: 0
              }}
              className="checklist-category-col"
            >
              <span
                className="title-style sortable"
                id="ob-page-title-style"
                style={{ paddingLeft: "7px" }}
                onClick={() => handleSortClick("code")}
              >
                ID
                {orderBy === "code" && sortingOrder ? (
                  sortingOrder === "desc" ? (
                    <Triangle />
                  ) : (
                    <Triangle style={{ transform: "rotate(180deg)" }} />
                  )
                ) : (
                  <></>
                )}
              </span>
            </Col>
            <Col
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-end",
                paddingRight: 0,
                paddingLeft: 0
              }}
              className="checklist-obligation-col"
            >
              <span
                className="title-style"
                id="ob-page-title-style-6"
                style={{ paddingLeft: "7px" }}
              >
                Obligation
              </span>
            </Col>
            <Col
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-end",
                paddingRight: 0,
                paddingLeft: 0
              }}
              className="checklist-action-col"
            >
              <span style={{marginLeft:"0.313rem"}} className="title-style" id="ob-page-title-style-7">
                Action
              </span>
            </Col>
            <Col
              // span={3}
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-end",
                paddingRight: 0,
                paddingLeft: 0
              }}
              className="checklist-assessment-col"
            >
              <span style={{marginLeft:"0.438rem"}} className="title-style" id="ob-page-title-style-8">
                Assessment
              </span>
            </Col>
            <Col
              // span={3}
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-end",
                paddingRight: 0,
                paddingLeft: 0
              }}
              className="checklist-due-col"
            >
              <span style={{marginLeft:"0.625rem"}} className="title-style" id="ob-page-title-style-9">
                Due Date
              </span>
            </Col>
            {/* <Col span={2}>
              <span className="title-style">Comments</span>
            </Col> */}
            <Col
              // span={2}
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-end",
                paddingRight: 0,
                paddingLeft: 0
              }}
              className="checklist-submit-col"
            >
              <span className="title-style" id="ob-page-title-style-10"></span>
            </Col>
          </Row>
          {filteredObligationsForm ? (
            <MainObligations
              id="ob-page-main-obligations"
              handleChangeObl={handleChangeObl}
              handleClearMessage={handleClearMessage}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              displayedItems={displayedItems}
              usersData={currentUsersData || []}
              setChecked={setChecked}
              Loading={loading}
              panelStyle={panelStyle}
              obligations={filteredObligationsForm}
              obligationsInCategory={filteredObligationsForm}
              myTask={false}
              organization={organizationId}
              selectedObligations={selectedObligations}
              setSelectedObligations={setSelectedObligations}
              scrolled={scrolled}
              setScrolled={setScrolled}
            />
          ) : (
            <></>
          )}

          <div className="collapse-margin" id="ob-page-collapse-margin">
            {" "}
          </div>
        </div>
      </div>

      {/* --------------Internal Regulations & Frameworks -------------------------------*/}
    </div>
  );
};

export default DpoMyChecklist;
